import { Howl } from 'howler';

export class musicOnOff {
  public static soundOn: boolean = true;
  public static musicOn: boolean = true;
}

const playMusic = {
  buttonClickSound: new Howl({
    src: [
      './sounds/button_sound.wav',
    ]
  }),
  winSound: new Howl({
    src: [
      './sounds/game-win.mp3',
    ]
  }),
  musicSound: new Howl({
    src: [
      './sounds/game-music.mp3',
    ]
  }),
  letterSelectSound: new Howl({
    src: [
      './sounds/letter-select.mp3',
    ]
  }),
  wordMatchSound: new Howl({
    src: [
      './sounds/word-match.mp3',
    ]
  })
}

export function playSound(soundName: string) {
  if (musicOnOff.soundOn) {
    switch (soundName) {
      case "buttonClickSound":
        playMusic.buttonClickSound.play();
        break;
      case "winSound":
        playMusic.winSound.play();
        break;
      case "letterSelectSound":
        playMusic.letterSelectSound.play();
        break;
      case "wordMatchSound":
        playMusic.wordMatchSound.play();
        break;
    }
  }

  if (musicOnOff.musicOn) {
    if (!playMusic.musicSound.playing()) {
      playMusic.musicSound.pause();
      // playMusic.musicSound.stop();
      playMusic.musicSound.loop(true);
      playMusic.musicSound.play();
    }
  }
}

export function pauseSound(soundName: string) {
  switch (soundName) {
    case "musicSound":
      playMusic.musicSound.pause();
      break;
  }
}
